import React, { PureComponent } from 'react';
import { Line } from 'react-chartjs-2';
import { translate } from 'react-i18next';
import moment from 'moment';

const convertTime = (timeSlot) => {
  if(timeSlot.time.split(":")[0] >= 12) {
    return { ...timeSlot, time: moment(timeSlot.time, ['HH:mm']) }
  }
  else{
    return { ...timeSlot, time: moment(timeSlot.time, ['HH:mm']).add(1, 'day') }
  }
}

class BrightnessGraph extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { brightness, t } = this.props;

    const sortedBrightnesses = brightness.map(convertTime).sort((a, b) => { return a.time - b.time })

    const data = {
      labels: [moment('12:00', 'HH:mm'), ...sortedBrightnesses.map(b => b.time), moment('12:00', 'HH:mm').add(1, 'day')],
      datasets: [
        {
          label: t('low'),
          data: [
            sortedBrightnesses.length > 0 ? sortedBrightnesses[sortedBrightnesses.length -1].low : 0,
            ...sortedBrightnesses.map(b => b.low),
            sortedBrightnesses.length > 0 ? sortedBrightnesses[sortedBrightnesses.length -1].low : 0,
          ],
          steppedLine: true,
          backgroundColor: '#fdea79',
          borderColor: 'rgba(0,0,0,0)', // appearantly border width 0 is not allowed
          borderWidth: 1,
          tooltip: false
        },
        {
          label: t('high'),
          data: [
            sortedBrightnesses.length > 0 ? sortedBrightnesses[sortedBrightnesses.length -1].high : 0,
            ...sortedBrightnesses.map(b => b.high),
            sortedBrightnesses.length > 0 ? sortedBrightnesses[sortedBrightnesses.length -1].high : 0,
          ],
          steppedLine: true,
          backgroundColor: '#fcd900',
          borderColor: 'rgba(0,0,0,0)', // appearantly border width 0 is not allowed
          borderWidth: 1,
          tooltip: false
        }
      ]
    }

    const options = {
      animation: false,
      tooltips: {
        enabled: false
      },
      elements: {
        point: {
          radius: 0
        }
      },
      scales: {
        yAxes: [{
          display: true,
          ticks: {
            max: 100,
            beginAtZero: true
          }
        }],
        xAxes: [{
          display: true,
          type: 'time',
          bounds: 'data',
          ticks: {
            source: 'labels',
            autoSkip: false
          },
          time: {
            displayFormats: {
              'millisecond': 'HH:mm',
              'second': 'HH:mm',
              'minute': 'HH:mm',
              'hour': 'HH:mm',
              'day': 'HH:mm',
              'week': 'HH:mm',
              'month': 'HH:mm',
              'quarter': 'HH:mm',
              'year': 'HH:mm'
            }
          }
        }]
      }
    }
    return (
      <Line data={data} options={options} />
    )
  }
}

export default translate('profile')(BrightnessGraph);



// WEBPACK FOOTER //
// ./src/components/profiles/BrightnessGraph.js